// Keep only the active viewport's server-paginated products in the live DOM.
if (!customElements.get('responsive-collection-products')) {
  customElements.define('responsive-collection-products', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.media = window.matchMedia('(max-width: 768px)');
      const mobile = this.querySelector('template[data-mobile-products]');
      if (this.media.matches && mobile) {
        this.replaceChildren(mobile.content.cloneNode(true));
      } else if (mobile) {
        mobile.remove();
      }
      // A different page size changes page offsets; restart on page one.
      this.onViewportChange = () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        window.location.replace(url.href);
      };
      this.media.addEventListener('change', this.onViewportChange);
    }
    disconnectedCallback() {
      this.media?.removeEventListener('change', this.onViewportChange);
    }
  });
}
